<template>
  <div>
    <img src="../../assets/loader.svg" alt="loader" />
  </div>
</template>